"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";
import { useLocation } from "react-router-dom";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const location = useLocation();
  const isNotebookPage = location.pathname.includes("/notebook");

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      offset="60px"
      closeButton={true}
      toastOptions={{
        className: "text-[12px] font-medium",
      }}
      style={
        {
          "--normal-bg": isNotebookPage && theme === "dark" ? "#1e1e2e" : "var(--popover)",
          "--normal-text": isNotebookPage && theme === "dark" ? "#cdd6f4" : "var(--popover-foreground)",
          "--normal-border": isNotebookPage && theme === "dark" ? "#313244" : "var(--border)",
          "--success-bg": isNotebookPage && theme === "dark" ? "#a6e3a1" : undefined,
          "--success-text": isNotebookPage && theme === "dark" ? "#11111b" : undefined,
          "--error-bg": isNotebookPage && theme === "dark" ? "#f38ba8" : undefined,
          "--error-text": isNotebookPage && theme === "dark" ? "#11111b" : undefined,
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
